import map from 'lodash/map.js';

import { handleResponseError } from '@/Helpers.js';
import axios from '@/plugins/axios.js';

export default {
    state: {
        tours: null,
    },

    getters: {
        /**
         * @param state
         * @returns {function(): boolean}
         */
        hasTours(state) {
            return () => state.tours && !!state.tours.length;
        },

        /**
         * @param state
         * @param getters
         * @returns {function(): *|string}
         */
        firstIncompleteTour(state, getters) {
            return () => {
                if (!getters.hasTours()) return null;

                return state.tours[0];
            };
        },

        /**
         * @returns {function(*): *}
         */
        tourName() {
            return tour => tour.tour.identifier;
        },

        /**
         * @returns {function(*): Array}
         */
        tourSteps() {
            return tour =>
                map(tour.tour.tips, tip => {
                    return {
                        target: tip.dom_element_identifier,
                        content: tip.body,
                        params: tip.settings,
                    };
                });
        },
    },

    actions: {
        /**
         * @param context
         * @param location
         * @returns {Promise<void>}
         */
        async fetchIncompleteToursForLocation(context, location) {
            try {
                const { data } = await axios.get(`/api/tours/incomplete?location=${location}`, { errorHandle: false });

                context.commit('SET', data.data);
            } catch (error) {
                handleResponseError(error);
            }
        },

        /**
         * @param context
         */
        purge(context) {
            context.commit('PURGE');
        },

        /**
         * @param context
         * @param guide
         * @param tour
         * @returns {Promise<void>}
         */
        async start(context, { guide, tour }) {
            if (!context.getters.hasTours()) return;

            const tourGuide = guide[context.getters.tourName(tour)];

            if (tourGuide) tourGuide.start();
        },

        /**
         * @param context
         * @param tour
         * @returns {Promise<void>}
         */
        async skip(context, tour) {
            await axios.post(`/api/tours/${tour.id}/skip`);
        },

        /**
         * @param context
         * @param tour
         * @returns {Promise<void>}
         */
        async complete(context, tour) {
            await axios.post(`/api/tours/${tour.id}/complete`);
        },
    },

    mutations: {
        /**
         * @param state
         * @param tours
         * @constructor
         */
        SET(state, tours) {
            state.tours = tours;
        },

        /**
         * @param state
         * @constructor
         */
        PURGE(state) {
            state.tours = null;
        },
    },
};
